<template lang="pug">
  #app.clearfix
    navbar.clearfix.navbar.navbar-default.container-fluid(
      v-if="authed && $route.path !== '/login'"
      placement='top'
      type='default'
    )
      a.navbar-brand(slot='brand' v-link="{path: '/products'}")
        span(style="color:#ffd700" v-if="domain === 'localhost'") Local
        //- span(style="color:#44ac35" v-if="domain === 'lantechcom.io'") Lantech
        span(style="color:#c22" v-if="domain === 'intrihub.io'") Intri
        span Hub
      dropdown(text='Switch' v-bind:class="['/products', '/firmware', '/privateMIB', '/firmware-download'].includes($route.path) ? 'active' : ''" v-if="user.role !== 'manufacturer'")
        li(v-bind:class="$route.path === '/products' ? 'active' : ''")
          a(v-link="{path: '/products'}")
            | Products
        li(v-bind:class="$route.path === '/firmware' ? 'active' : ''")
          a(v-link="{path: '/firmware'}")
            | Firmware
        li(v-bind:class="$route.path === '/privateMIB' ? 'active' : ''")
          a(v-link="{path: '/privateMIB'}")
            | Private MIB
        li(v-bind:class="$route.path === '/license' ? 'active' : ''" v-if="isIntrising || user.role === 'admin'")
          a(v-link="{path: '/license'}")
            | License
      //- li(v-bind:class="$route.path === '/mt-download' ? 'active' : ''" v-if="(user.email && user.email.endsWith('@intrising.com.tw')) || (user.email && user.email === 'lewis@lantechcom.tw') || user.role === 'manufacturer'")
          //- a(v-link="{path: '/mt-download'}")
            //- | MT Download
      dropdown(text='Utility' v-bind:class="['/instaviewer'].includes($route.path) ? 'active' : ''" v-if="user.role !== 'manufacturer'")
        li(v-bind:class="$route.path === '/instaviewer' ? 'active' : ''")
          a(v-link="{path: '/instaviewer'}")
            | InstaViewer
      li(v-bind:class="$route.path === '/documentation' ? 'active' : ''" v-if="user.role === 'admin' || user.role === 'salesperson'")
        a(v-link="{path: '/documentation'}")
          | Documentation
      li(v-bind:class="$route.path === '/faq' ? 'active' : ''" v-if="user.role !== 'manufacturer'")
        a(v-link="{path: '/faq'}")
          | FAQ
      //- Leaves the Hub for a separate service, so it is a plain href, not a v-link route.
        No domain guard: this branch is the IntriHub build (the lantechcom.io brand above is
        commented out), so it only ever runs on intrihub.io. The master branch carries the
        same link pointing at security.lantechcom.io.
      li
        a(
          href="https://security.intrihub.io"
          target="_blank"
          rel="noopener noreferrer"
          title="Opens security.intrihub.io in a new tab"
        )
          | Security
          i.fa.fa-external-link(style="margin-left: 5px; font-size: 0.85em;" aria-hidden="true")
      dropdown(v-bind:text='user.email' slot='right')
        li
          a(@click="showModal = true")
            i.fa.fa-lock
            | &nbsp;Change Password
        li
          a(@click="logout")
            i.fa.fa-sign-out
            | &nbsp;Logout
        li
          a Ver. {{ version }}
    .main
      router-view
    alert(
      v-bind:type="alertData.type"
      v-bind:show.sync="alertData.show"
      v-bind:duration="1000"
      width="280px"
      placement="top-right"
      dismissable)
      span.icon-ok-circled.alert-icon-float-left
      strong {{ alertData.title }}
      p {{ alertData.content }}

    modal(:show.sync="showModal" effect="fade" width="400")
      div.modal-header(slot="modal-header")
        .modal-title: h4 Change Password
      div.modal-body(slot="modal-body")
        form(style="height: 100px;")
          .form-group.col-md-12.clearfix
            .col-md-4.form-label.clearfix
              label.control_label
                | New password
            .col-md-8.no_pad.clearfix
              input.form-control.input-sm(type="password" v-model='newPwd' v-bind:class="pwdValidate.isValid ? '' : 'error'")
              span.text-danger(v-if="!pwdValidate.isValid") {{ pwdValidate.message }}
          .form-group.col-md-12.clearfix
            .col-md-4.form-label.clearfix
              label.control_label
                | Confirm password
            .col-md-8.no_pad.clearfix
              input.form-control.input-sm(type="password" v-model='newPwdCheck' v-bind:class="newPwd !== newPwdCheck ? 'error' : ''")
              span.text-danger(v-if="newPwd !== newPwdCheck") Password mismatch.
      div.modal-footer(slot="modal-footer")
        button(type="button" class="btn btn-default" @click="closeChangePwdModal") Cancel
        button(type="button" class="btn btn-success" v-bind:disabled="newPwd === '' || newPwdCheck === '' || newPwd !== newPwdCheck || !  pwdValidate.isValid" @click="setNewPassword") Save

</template>

<script>
import { navbar, dropdown, alert, modal } from 'vue-strap'
import { version } from '../package.json'
import { firebaseLogout, AUTH_STATE_AUTHED, firebaseSetPwd } from './index'
import permissionsMixin from './mixins/permissionsMixin.js'

const domain = window.location.hostname
const link = document.querySelector("link[rel*='icon']") || document.createElement('link')
link.type = 'image/x-icon'
link.rel = 'shortcut icon'

if (domain === 'localhost') {
  document.title = 'Hub for localhost'
} else if (domain === 'intrihub.io') {
  document.title = 'IntriHub'
  link.href = '/static/favicon-intrising.png'
} else document.title = 'Hub'

document.getElementsByTagName('head')[0].appendChild(link)

export default {
  mixins: [permissionsMixin],
  components: {
    navbar,
    dropdown,
    alert,
    modal
  },
  data: () => ({
    domain,
    version,
    alertList: [],
    alertData: {
      type: '',
      title: '',
      show: false,
      content: ''
    },
    showModal: false,
    newPwd: '',
    newPwdCheck: ''
  }),
  vuex: {
    getters: {
      user: state => state.user,
      authed: state => state.authState === AUTH_STATE_AUTHED
    }
  },
  methods: {
    logout () {
      firebaseLogout().then(() => {
        // this.alert('success', '', 'Logout Success')
        this.$router.replace('/login')
      })
    },
    alert ({type, title, content}) {
      let newAlert = {
        type,
        title,
        content,
        show: true
      }
      this.alertList.push(newAlert)
    },
    closeChangePwdModal () {
      this.showModal = false
      this.newPwd = ''
      this.newPwdCheck = ''
    },
    async setNewPassword () {
      await firebaseSetPwd(this.newPwd).then(() => {
        this.showModal = false
        this.newPwd = ''
        this.newPwdCheck = ''
        return this.logout()
      }).catch((err) => {
        console.error(err)
        // firebaseSetPwdErr = err
      })
    }
  },
  events: {
    alert (e) {
      this.alert(e)
    }
  },
  computed: {
    pwdValidate () {
      const { newPwd } = this
      let isValid = true
      let message = []
      if (newPwd.length < 6) {
        isValid = isValid && false
        message.push('Minimum length: 6 characters')
      }
      if (newPwd.length > 100) {
        isValid = isValid && false
        message.push('Maximum length: 100 characters')
      }
      if (!/^\w+$/.test(newPwd)) {
        isValid = isValid && false
        message.push('No numbers/special characters required')
      }
      return {
        isValid,
        message: message.join(', ')
      }
    }
  },
  ready () {
    setInterval(() => {  // make alerts wait in list
      if (this.alertList.length) {
        this.alertData = this.alertList.shift()
        this.alertData.show = false
        setTimeout(() => {
          this.alertData.show = true
        }, 1500)
      }
    }, 2000)
  }
}
</script>

<style lang='scss'>
@import './scss/w3.css';
@import './main.scss';
@import "~font-awesome/css/font-awesome.min.css";

html {
  height: 100%;
}

body {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

#app {
  width: 100vw;
  height:  100vh;
}
.main {
  margin-top: 40px;
}

// overwrite the original setting of all dropdowns
.dropdown-menu {
  max-height: 300px;
  overflow: auto;
}

</style>



// WEBPACK FOOTER //
// App.vue?3b014e16